import React from "react";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home";
import Animal from "../pages/Animal";
import LoginPage from "../pages/LoginPage";
import Trv from "../pages/Trv";
import PainelBordo from "../pages/PainelBordo";

//Admin pages
import Admin from "../pages/Admin";
import DashboardAdm from "../pages/DashboardAdm";
import AnimaisConsultaAdm from "../pages/AnimaisConsultaAdm"
import AnimaisCadastroAdm from "../pages/AnimaisCadastroAdm"
import PermissoesAdm from "../pages/PermissoesAdm";
import PontuacaoGeral from "../pages/PontuacaoGeral";
import VendasSuricato from "../pages/VendasSuricato";
import RelatorioMetas from "../pages/RelatorioMetas";
import GerenciarMetasExtraAdm from "../pages/GerenciarMetasExtraAdm"; 
import TrvGerenciamentoCluster from "../pages/TrvGerenciamentoCluster";
import TrvCadastroCluster from "../pages/TrvCadastroCluster";
import HabilitarRegioes from "../pages/HabilitarRegioesAdm";
import AnimaisMetaFlexivelAdm from "../pages/AnimaisMetaFlexivelAdm";
import GerenciarClusterAdm from "../pages/GerenciarClusterAdm";
import ListarClusterAdm from "../pages/ListarClusterAdm";
import EditarClusterAdm from "../pages/EditarClusterAdm";
import QuadroVendedores from "../pages/QuadroVendedores";

import { isUserAuthenticated, logout, handleLogin, isTokenExpired, tryAuthenticateViaCookie } from "../auth";
import { useEffect, useState } from "react";
import MetasServicoAdm from "../pages/MetasServicoAdm";
import MetasDepartamentosAdm from "../pages/MetasDepartamentosAdm";
import MetasGeraisAdm from "../pages/MetasGeraisAdm";
import MetasExtranetAdm from "../pages/MetasExtranetAdm";
import OceanoAzul from "../pages/OceanoAzul";
import VacaLeiteira from "../pages/VacaLeiteira";
import IndicesProjecaoImportacao from "../pages/IndicesProjecaoImportacao";
import IndicesProjecaoGerenciamento from "../pages/IndicesProjecaoGerenciamento";
import QuadroVendedoresImportacao from "../pages/QuadroVendedoresImportacao";
import SaqueFacil from "../pages/SaqueFacil";
import MetaVendedorGlobalAdm from "../pages/MetaVendedorGlobalAdm/Index";
import SaqueFacilImportacao from "../pages/SaqueFacilImportacao";
import RemuneracaoGerentes from "../pages/RemuneracaoGerentes";
import RemuneracaoGerentesImportacao from "../pages/RemuneracaoGerentesImportacao";
import RemuneracaoVendedores from "../pages/RemuneracaoVendedores";
import RemuneracaoVendedoresImportacao from "../pages/RemuneracaoVendedoresImportacao";
import QuadranteMetaMesVend from "../pages/QuadranteMetaMesVend";

function RoutesComponent() {
  // Função que protege as rotas autenticadas
  const ProtectedRoute = ({ element, isAdmin=false, ...rest }) => {
    const [isChecking, setIsChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
      const checkAuth = async () => {
        const authenticated = await tryAuthenticateViaCookie(false);
        
        if (authenticated && isUserAuthenticated(isAdmin)) {
          setIsAuthenticated(true);
          sessionStorage.removeItem('manual_logout');
        } else {
          setIsAuthenticated(false);
        }
        
        setIsChecking(false);
      };

      checkAuth();
    }, [isAdmin]);

    if (isChecking) {
      return <div>Verificando autenticação...</div>;
    }

    return isAuthenticated ? element : <Navigate to="/login" />;
  };

  // Função para verificar o token periodicamente
  const checkTokenExpiration = () => {
    const token = localStorage.getItem("token");
    if (token && isTokenExpired(token)) {
      logout();
      window.location.href = "/login"; // Redirecionar para /login
    }
  };

  
  useEffect(() => {
    checkTokenExpiration();

    // Configurar verificação de token a cada x minutos
    const intervalMinute = 60; // Invervalo em minutos em que verificação será feita
    const intervalId = setInterval(checkTokenExpiration, intervalMinute * 60 * 1000);
    return () => clearInterval(intervalId); // Limpar o intervalo quando o componente for desmontado
  }, []);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <ProtectedRoute element={<Home />}/>
    },
    {
      path: "/animal",
      element: <ProtectedRoute element={<Animal />} />
    },
    {
      path: "/trv",
      element: <ProtectedRoute element={<Trv />} />
    },
    {
      path: "/loginprovisorio",
      element: <LoginPage onLogin={handleLogin} manutencao={ false } />
    },
    {
      path: "/login",
      element: <LoginPage onLogin={handleLogin} manutencao={ true } />
    },
    {
      path: "/painelbordo",
      element: <ProtectedRoute element={<PainelBordo />} />
    },
    {
      path: "/oceanoazul",
      element: <ProtectedRoute element={<OceanoAzul />} />
    },
    {
      path: "/vacaleiteira",
      element: <ProtectedRoute element={<VacaLeiteira />} />
    },
    {
      path: "/admin",
      element: <ProtectedRoute element={<Admin />} isAdmin={true}/>,
      children: [
        {
          path: "dashboard",
          element: <ProtectedRoute element={<DashboardAdm/>} isAdmin={true} />
        },
        {
          path: "animais/consulta",
          element: <ProtectedRoute element={<AnimaisConsultaAdm/>} isAdmin={true} />
        },
        {
          path: "animais/cadastro",
          element: <ProtectedRoute element={<AnimaisCadastroAdm/>} isAdmin={true} />
        },
        {
          path: "animais/meta-flexivel",
          element: <ProtectedRoute element={<AnimaisMetaFlexivelAdm/>} isAdmin={true} />
        },
        {
          path: "painel-bordo/metas-servicos",
          element: <ProtectedRoute element={<MetasServicoAdm/>} isAdmin={true} />
        },
        {
          path: "painel-bordo/metas-departamentos",
          element: <ProtectedRoute element={<MetasDepartamentosAdm/>} isAdmin={true} />
        },
        {
          path: "painel-bordo/metas-gerais",
          element: <ProtectedRoute element={<MetasGeraisAdm/>} isAdmin={true} />
        },
        {
          path: "gerenciarMetasExtra/gerenciar",
          element: <GerenciarMetasExtraAdm />,
        },
        {

          path: "/admin/uploadMetasExtra/metas-extranet",
          element:  <MetasExtranetAdm/>,
          
        },
        {
      path: "gerenciarMetasExtra/meta-vendedor-global",
      element: <ProtectedRoute element={<MetaVendedorGlobalAdm />} isAdmin={true} />
        },
        {
          path: "permissoes",
          element: <ProtectedRoute element={<PermissoesAdm/>} isAdmin={true} />
        },
        {
          path: "pontuacao-geral",
          element: <ProtectedRoute element={<PontuacaoGeral/>} isAdmin={true} />
        },
        {
          path: "relatorio-metas",
          element: <ProtectedRoute element={<RelatorioMetas/>} isAdmin={true} />
        },
        {
          path: "vendas-suricato",
          element: <ProtectedRoute element={<VendasSuricato/>} isAdmin={true} />
        },
        {
          path: "trv/gerenciamentocluster",
          element: <ProtectedRoute element={<TrvGerenciamentoCluster/>} isAdmin={true} />
        },
        {
          path: "trv/cadastrocluster",
          element: <ProtectedRoute element={<TrvCadastroCluster/>} isAdmin={true} />
        },
        {
          path: "habilitar-regioes",
          element: <ProtectedRoute element={<HabilitarRegioes/>} isAdmin={true}/>
        },
        {
          path: "cluster/gerenciarcluster",
          element: <ProtectedRoute element={<GerenciarClusterAdm/>} isAdmin={true}/>
        },
        {
          path: "cluster/listarcluster",
          element: <ProtectedRoute element={<ListarClusterAdm/>} isAdmin={true}/>
        },
        {
          path: "cluster/editarcluster",
          element: <ProtectedRoute element={<EditarClusterAdm/>} isAdmin={true}/>
        },
        {
          path: "indiceprojecao/importacao",
          element: <ProtectedRoute element={<IndicesProjecaoImportacao/>} isAdmin={true} />
        },
        {
          path: "indiceprojecao/gerenciamento",
          element: <ProtectedRoute element={<IndicesProjecaoGerenciamento/>} isAdmin={true} />
        },
        {
          path: "quadro-vendedores/importacao",
          element: <ProtectedRoute element={<QuadroVendedoresImportacao/>} isAdmin={true} />
        },
        {
          path: "quadro-vendedores/listar",
          element: <ProtectedRoute element={<QuadroVendedores/>} isAdmin={true} />
        },
        {
          path: "saque-facil",
          element: <ProtectedRoute element={<SaqueFacil/>} isAdmin={true} />
        },
        {
          path: "saque-facil/importacao",
          element: <ProtectedRoute element={<SaqueFacilImportacao/>} isAdmin={true} />
        },
        {
          path: "quadrante-excelencia",
          element: <ProtectedRoute element={<QuadranteMetaMesVend/>} isAdmin={true} />
        },
        {
          path: "Quadrante/MetaMesVend",
          element: <ProtectedRoute element={<QuadranteMetaMesVend/>} isAdmin={true} /> 
        },
        {
          path: "remuneracao/vendedores",
          element: <ProtectedRoute element={<RemuneracaoVendedores/>} isAdmin={true} />
        },
        {
          path: "remuneracao/vendedores/importacao",
          element: <ProtectedRoute element={<RemuneracaoVendedoresImportacao/>} isAdmin={true} />
        },
        {
          path: "remuneracao/gerentes",
          element: <ProtectedRoute element={<RemuneracaoGerentes/>} isAdmin={true} />
        },
        {
          path: "remuneracao/gerentes/importacao",
          element: <ProtectedRoute element={<RemuneracaoGerentesImportacao/>} isAdmin={true} />
        }
      ]
    },
    {
      
    },
    {
      path: "*",
      element: <Navigate to="/login" />
    }
  ])


  return (
    <RouterProvider router={router} />
  );
}

export default RoutesComponent;
